/**
 * Community shell tab IA (5c):
 * Hunting Buddies · Find a Club · Find a Processor
 * Camp Essentials stays flag-gated — not a shell segment when off.
 */

export const COMMUNITY_TAB_BUDDIES = 'buddies';
export const COMMUNITY_TAB_FIND_CLUB = 'find-club';
export const COMMUNITY_TAB_FIND_PROCESSOR = 'find-processor';

export const COMMUNITY_BUDDIES_PATH = '/hunting-buddies';
export const COMMUNITY_FIND_CLUB_PATH = '/community/find-club';
export const COMMUNITY_FIND_PROCESSOR_PATH = '/community/find-processor';
export const COMMUNITY_SUGGEST_STORE_PATH = '/community/suggest-store';
export const COMMUNITY_DEFAULT_PATH = COMMUNITY_BUDDIES_PATH;

export const COMMUNITY_SHELL_TABS = [
  { id: COMMUNITY_TAB_BUDDIES, label: 'Hunting Buddies', path: COMMUNITY_BUDDIES_PATH },
  { id: COMMUNITY_TAB_FIND_CLUB, label: 'Find a Club', path: COMMUNITY_FIND_CLUB_PATH },
  { id: COMMUNITY_TAB_FIND_PROCESSOR, label: 'Find a Processor', path: COMMUNITY_FIND_PROCESSOR_PATH },
];

export function parseCommunityTab(pathname = '') {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  if (path === COMMUNITY_FIND_PROCESSOR_PATH || path.startsWith(`${COMMUNITY_FIND_PROCESSOR_PATH}/`)) {
    return COMMUNITY_TAB_FIND_PROCESSOR;
  }
  if (path === COMMUNITY_FIND_CLUB_PATH || path.startsWith(`${COMMUNITY_FIND_CLUB_PATH}/`)) {
    return COMMUNITY_TAB_FIND_CLUB;
  }
  return COMMUNITY_TAB_BUDDIES;
}

export function communityPathForTab(tabId) {
  const match = COMMUNITY_SHELL_TABS.find((tab) => tab.id === tabId);
  return match?.path || COMMUNITY_DEFAULT_PATH;
}
